export const USER_MESSAGES_SUCCESS = {
  SAVE_SUCCESS: "Usuario guardado exitosamente.",
  DISABLE_SUCCESS: "Usuario deshabilitado exitosamente.",
  ENABLE_SUCCESS: "Usuario habilitado exitosamente.",
};

export const USER_MESSAGES_ERROR = {
  SAVE_ERROR: "Error al guardar el usuario. Por favor, inténtalo de nuevo.",
  DISABLE_ERROR:
    "Error al deshabilitar el usuario. Por favor, inténtalo de nuevo.",
  ENABLE_ERROR:
    "Error al habilitar el usuario. Por favor, inténtalo de nuevo.",
};
